import ShellCartFloatingButton from './ShellCartFloatingButton';

export default ShellCartFloatingButton;
